import type { MultichainConfig } from 'types/multichain';

import config from 'configs/app';
// Avoid indirect runtime checks to help bundlers tree-shake client/server branches

const multichainConfig: () => MultichainConfig | undefined = () => {
  if (!config.features.opSuperchain.isEnabled) {
    return;
  }

  if (typeof window !== 'undefined') {
    return window.__multichainConfig;
  }

  // Import server-only module lazily and via eval to avoid static bundling
  // eslint-disable-next-line no-eval
  const req = eval('require');
  const multichainConfigNodejs = req('configs/multichain/config.nodejs');
  return multichainConfigNodejs.getValue();
};

export default multichainConfig;
